import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-1 pr-4" }
const _hoisted_2 = { class: "text-base-bold text-racq-dark-grey" }
const _hoisted_3 = { class: "text-sm text-racq-med-gray" }
const _hoisted_4 = { class: "sr-only" }

import { computed } from 'vue';
import { FormKit } from '@formkit/vue';
import { OFF, ON } from '@/constants/general-words.const';
import { IToggleSwitchCardItem } from '@/interfaces/components/toggle-switch-card.interface';


export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleSwitchCardItem',
  props: {
    id: {},
    title: {},
    description: {},
    modelValue: { type: Boolean },
    disabled: { type: Boolean },
    noPanel: { type: Boolean },
    vertAlignment: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const labelValue = computed(() => (props?.modelValue ? ON : OFF));
const sectionSchemaToggleLabel = {
  label: {
    $el: 'span',
    attrs: {
      'aria-label': 'Enable notifications',
    },
  },
};

const emit = __emit;

function onInput(value: boolean) {
  emit('update:modelValue', value);
  emit('change', { id: props.id, value });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{
      'border-t-0 border-l-0 border-r-0 last:border-b-0 rounded-none first:pt-1 last:pb-0 !px-1 pt-5 pb-3':
        props.noPanel,
      ' flex !items-start': props.vertAlignment,
    }, "border border-solid border-racq-pale-blue-border rounded px-5 py-7 md:px-8 flex items-center justify-between gap-6"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.description), 1),
      _renderSlot(_ctx.$slots, "otheractions")
    ]),
    _createVNode(_unref(FormKit), {
      type: "nativeToggle",
      value: _ctx.modelValue,
      disabled: _ctx.disabled,
      label: labelValue.value,
      sectionsSchema: sectionSchemaToggleLabel,
      onInput: onInput
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, _toDisplayString(labelValue.value), 1)
      ]),
      _: 1
    }, 8, ["value", "disabled", "label"])
  ], 2))
}
}

})